import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgArrowRight = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <path
      fill={_.color}
      d="M8.529 2.529a.748.748 0 0 0-1.058 1.057l3.656 3.664H2.75a.75.75 0 0 0 0 1.5h8.378l-3.66 3.653a.753.753 0 1 0 1.064 1.065L14 8z"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgArrowRight);
export default ForwardRef;
